module.exports = __webpack_public_path__ + "static/usage_input_num-d83e6158d341da17900a1087d40a9203.jpg";